import {assignSafely} from 'shared/web';

import {EquipmentScoreType} from '../../../../../types/MarketType';

function addStringFeatures(
  map: Record<string, boolean>,
  features: string[] | undefined,
  value: boolean
) {
  (features ?? []).forEach((featureCode) => {
    assignSafely(map, featureCode, value);
  });
}

export function getEquipmentFeaturePresenceMap(
  equipmentScore: EquipmentScoreType | undefined
): Record<string, boolean> {
  if (!equipmentScore) {
    return {};
  }

  const presenceMap: Record<string, boolean> = {};

  addStringFeatures(presenceMap, equipmentScore.missing_highlighted_features, false);
  addStringFeatures(presenceMap, equipmentScore.missing_non_highlighted_features, false);
  addStringFeatures(presenceMap, equipmentScore.highlighted_features, true);
  addStringFeatures(presenceMap, equipmentScore.available_non_highlighted_features, true);

  return presenceMap;
}
